@if (currentPipeline$ | async; as currentPipeline) {
  @if (currentPipeline.pipelineId) {
    @if (savingChanges$ | async) {
      <glxy-loading-spinner [fullHeight]="true" [size]="'large'"></glxy-loading-spinner>
    } @else {
      <div class="pipeline-forms" [formGroup]="pipelineForm">
        <glxy-form-field [bottomSpacing]="false">
          <glxy-label>{{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.FORMS.NAME_TITLE' | translate }}</glxy-label>
          <input
            type="text"
            formControlName="name"
            placeholder="{{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.FORMS.NAME_PLACEHOLDER' | translate }}"
            matInput
          />
        </glxy-form-field>
        <div class="pipeline-stage-form-title-group">
          <div class="pipeline-stage-form-title">
            {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.FORMS.STAGES_TITLE' | translate }}
          </div>
          <div class="pipeline-stage-form-subtitle">
            {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.FORMS.STAGES_SUBTITLE' | translate }}
          </div>
        </div>
        <mat-card>
          <div class="pipeline-stages-header">
            <div class="row">
              <div class="col col-sm-8 pipeline-stages-content">
                {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.FORMS.STAGE_NAME' | translate }}
              </div>
              <div class="col col-sm-4 pipeline-stages-content">
                {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.FORMS.STAGE_PROBABILITY' | translate }}
              </div>
            </div>
          </div>
          <mat-divider></mat-divider>
          <mat-card-content>
            @for (stageForm of stages.controls; track stageForm; let i = $index, last = $last) {
              <div class="row pipeline-stages-form-group" [formGroup]="stageForm">
                <div class="col col-sm-8 pipeline-stages-content">
                  <glxy-form-field [bottomSpacing]="last ? false : 'small'">
                    <input
                      type="text"
                      formControlName="name"
                      placeholder="{{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.FORMS.STAGE_NAME' | translate }}"
                      matInput
                    />
                  </glxy-form-field>
                </div>
                <div class="col col-sm-4 pipeline-stages-content">
                  <div class="close-probability">
                    <glxy-form-field
                      [bottomSpacing]="last ? false : 'small'"
                      [suffixText]="'%'"
                      class="probability-input"
                    >
                      <input type="number" formControlName="probability" min="0" max="99" matInput />
                    </glxy-form-field>
                    <button mat-icon-button type="button" (click)="deleteDisplayStage(i)">
                      <mat-icon class="pipeline-stages-button">close</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              @if (!last) {
                <mat-divider></mat-divider>
              }
            }
          </mat-card-content>
          <mat-card-actions>
            <button mat-button type="button" color="primary" class="pipeline-stages-content" (click)="addStage()">
              + {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.BUTTONS.ADD_STAGE' | translate }}
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
      <glxy-sticky-footer *ngIf="currentPipeline.pipelineId">
        <button mat-flat-button color="primary" type="button" (click)="saveChanges()">
          {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.BUTTONS.SAVE' | translate }}
        </button>
        <button mat-stroked-button (click)="cancelChanges()">
          {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.BUTTONS.CANCEL' | translate }}
        </button>
        <glxy-sticky-footer-secondary>
          <button mat-stroked-button color="warn" type="button" (click)="deletePipeline(currentPipeline.pipelineId)">
            {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.BUTTONS.DELETE_PIPELINE' | translate }}
          </button>
        </glxy-sticky-footer-secondary>
      </glxy-sticky-footer>
    }
  } @else {
    <glxy-empty-state>
      <glxy-empty-state-title>
        {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.EMPTY_STATE.TITLE' | translate }}
      </glxy-empty-state-title>
      <p>
        {{ 'FRONTEND.SALES_UI.PIPELINE.SETTINGS.EMPTY_STATE.MESSAGE' | translate }}
      </p>
    </glxy-empty-state>
  }
} @else {
  <glxy-loading-spinner [fullHeight]="true" [size]="'large'"></glxy-loading-spinner>
}
